module.exports = __webpack_public_path__ + "static/media/3.a6a10041.png";